import React from 'react';

interface EmailWizardStepIndicatorProps {
    currentStep: number;
}

const EmailWizardStepIndicator: React.FC<EmailWizardStepIndicatorProps> = ({
    currentStep,
}) => {
    const steps = ['Tischauswahl', 'E-Mail Inhalt', 'Überprüfung'];

    return (
        <div className="step-indicator">
            {steps.map((label, index) => {
                const stepNumber = index + 1;
                return (
                    <div 
                        key={stepNumber} 
                        className={`step-item ${currentStep === stepNumber ? 'active' : ''} ${currentStep > stepNumber ? 'completed' : ''}`}
                    >
                        <div className="step-number">{stepNumber}</div>
                        <div className="step-label">{label}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default EmailWizardStepIndicator;
